import React from "react";
import Defaultinput from "./DefaultInput.tsx";
import SuggestedInput from "./SuggestedInput.tsx";

type Props = {
  isSuggested: boolean;
  handleChangeChatData: (text: string) => void;
  leadId?: string | number;
  addMessagesWithDelay: (items: any[]) => void;
  suggestedText?: string;
  onDraftChange?: (text: string) => void;
  answerType?: string;
};

const ChatFooter: React.FC<Props> = ({
  isSuggested,
  handleChangeChatData,
  leadId,
  addMessagesWithDelay,
  suggestedText,
  onDraftChange,
  answerType,
}) => {
  return (
    <div className="flex justify-center w-full">
      {isSuggested ? (
        <SuggestedInput
          handleChangeChatData={handleChangeChatData}
          leadId={leadId}
          answerType={answerType}
        />
      ) : (
        <Defaultinput
          handleChangeChatData={handleChangeChatData}
          addMessagesWithDelay={addMessagesWithDelay}
          suggestedText={suggestedText}
          onDraftChange={onDraftChange}
          leadId={leadId}
          isSuggested={isSuggested}
        />
      )}
    </div>
  );
};

export default ChatFooter;
